import { ReactComponent as AddIcon } from "../../assets/icons/add.svg";
import styles from "../../styles/components/MailsToolbar.module.css";

import ChoiceChip from "../../ui/selectors/ChoiceChip.jsx";
import SearchInput from "../../ui/inputs/SearchInput.jsx";
import Button from "../../ui/buttons/Button.jsx";
import useWhatsAppEnabled from "../../hooks/useWhatsAppEnabled";

const TemplatesToolbar = ({
  onSearchChange,
  onFilterChange,
  onOpenReview,
  onNewTemplateFile,
  selectedFilter,
  isTemplateSelected,
  onUploadAttachmentFile,
  onNewTemplateGroup,
  onNewWhatsAppTemplate,
  newWhatsAppLabel = "Nueva Plantilla",
}) => {
  const whatsappEnabled = useWhatsAppEnabled();
  const handleFilterChange = (value) => {
    onFilterChange?.(value);
    if (value === "op2") {
      onOpenReview?.();
    }
  };

  return (
    <div className={styles.toolbar}>
      <div className={styles.searchBarParent}>
        <div className={styles.filters}>
          <SearchInput onSearch={onSearchChange} width={241} height={40} />

          {!isTemplateSelected && (
            <div className={styles.filterGroup}>
              <ChoiceChip
                label="Plantillas"
                selected={selectedFilter === "op1"}
                onClick={() => handleFilterChange("op1")}
                height={40}
                iconSize={0}
                fontWeight={500}
                padding="12px 16px"
                selectedColor="var(--text-cta-primary)"
                unselectedColor="var(--text-tertiary)"
                selectedBackground="var(--surface-accent-hover)"
                unselectedBackground="transparent"
              />

              <ChoiceChip
                label="Archivos Adjuntos"
                selected={selectedFilter === "op2"}
                onClick={() => handleFilterChange("op2")}
                height={40}
                iconSize={0}
                fontWeight={500}
                padding="12px 16px"
                selectedColor="var(--text-cta-primary)"
                unselectedColor="var(--text-tertiary)"
                selectedBackground="var(--surface-accent-hover)"
                unselectedBackground="transparent"
              />

              {whatsappEnabled && (
                <ChoiceChip
                  label="WhatsApp"
                  selected={selectedFilter === "op3"}
                  onClick={() => handleFilterChange("op3")}
                  height={40}
                  iconSize={0}
                  fontWeight={500}
                  padding="12px 16px"
                  selectedColor="var(--text-cta-primary)"
                  unselectedColor="var(--text-tertiary)"
                  selectedBackground="var(--surface-accent-hover)"
                  unselectedBackground="transparent"
                />
              )}
            </div>
          )}
        </div>
      </div>

      {selectedFilter === "op3" ? (
        <Button
          type="button"
          iconLeft={<AddIcon />}
          onClick={onNewWhatsAppTemplate}
          width={140}
          height={40}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 8,
            paddingRight: 16,
            background: "var(--surface-accent-hover)",
            color: "var(--text-cta-primary)",
            fontSize: 13,
            fontFamily: "DM Sans",
            fontWeight: 500,
            gap: 0,
          }}
        >
          {newWhatsAppLabel}
        </Button>
      ) : selectedFilter === "op1" ? (
        isTemplateSelected ? (
          <Button
            type="button"
            iconLeft={<AddIcon />}
            onClick={onNewTemplateFile}
            width={124}
            height={40}
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 8,
              paddingRight: 16,
              background: "var(--surface-accent-hover)",
              color: "var(--text-cta-primary)",
              fontSize: 13,
              fontFamily: "DM Sans",
              fontWeight: 500,
              gap: 0,
            }}
          >
            Nuevo Template
          </Button>
        ) : (
          <Button
            type="button"
            iconLeft={<AddIcon />}
            onClick={onNewTemplateGroup}
            width={124}
            height={40}
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 8,
              paddingRight: 16,
              background: "var(--surface-accent-hover)",
              color: "var(--text-cta-primary)",
              fontSize: 13,
              fontFamily: "DM Sans",
              fontWeight: 500,
              gap: 0,
            }}
          >
            Nueva Plantilla
          </Button>
        )
      ) : (
        <Button
          type="button"
          iconLeft={<AddIcon />}
          onClick={onUploadAttachmentFile}
          width={159}
          height={40}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 8,
            paddingRight: 16,
            background: "var(--surface-accent-hover)",
            color: "var(--text-cta-primary)",
            fontSize: 13,
            fontFamily: "DM Sans",
            fontWeight: 500,
            gap: 0,
          }}
        >
          Nuevo Archivo Adjunto
        </Button>
      )}
    </div>
  );
};

export default TemplatesToolbar;
